import React from "react"
import { FaCheck } from "react-icons/fa"

const EmailConfirmation = () => {
  const email = localStorage.getItem("email")
  return (
    <div className="h-screen flex items-center justify-center">
      <div className="w-full flex flex-col gap-4 text-center items-center justify-center max-w-md mx-auto">
        <div className="w-12 h-12 bg-yellowcolor/40 rounded-full flex items-center justify-center">
          <div className="w-8 h-8 bg-yellowcolor/50 text-yellowcolor rounded-full flex items-center justify-center">
            <FaCheck className="text-lg" />
          </div>
        </div>
        <h1 className="font-bold text-2xl capitalize text-black dark:text-white">
          Registration Submitted
        </h1>
        <p className="text-sm text-gray-400 mt-2">
          Thank you for registering with FarmerKonnect! Your account is now under review. You will receive an update via email within 72 hours after our admin team completes the verification process
        </p>

        <a href="/" className="w-full">
          <button className="w-full bg-yellowcolor text-black font-semibold py-3 rounded-md text-base transition-colors duration-200 shadow-none">
            Go to Hompage
          </button>
        </a>
      </div>
    </div>
  )
}


export default EmailConfirmation
